import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { SvgIcon } from 'common/react/components/SvgIcon';
import { getTranslation } from 'common/react/utils/translations';
import { getPredictorTrackingLabel } from 'widgets/player-awards-tracker/js/components/Leaderboard/components/table/utils';

export const FavouriteButton = ({
    player,
    onPlayerFavouriteClick,
    favourites,
    isAFLW
}) => {
    const isFavourited = useMemo(() => {
        return favourites.some((item) => item.providerId === player.playerId);
    }, [favourites, player.playerId]);

    const handleClick = (playerId) => {
        if (!isFavourited) {
            /* eslint-disable camelcase */
            PULSE.app.tracking.recordEvent(
                PULSE.app.common.CONSTANTS.TRACKING.EVENTS.SELECT.FAVOURITE,
                {
                    eventData: {
                        favourite_name:
                            `${player.givenName} ${player.surname}`.toLowerCase(),
                        CD_player_ID: player.playerId,
                        component_name: getPredictorTrackingLabel(
                            isAFLW,
                            'player pin'
                        ),
                        component_type: 'player pin'
                    }
                }
            );
            /* eslint-enable camelcase */
        }

        onPlayerFavouriteClick(playerId);
    };

    return (
        <button
            className="stats-table__favourite-button"
            data-favourite-id={player.playerId}
            data-favourite-provider-id={player.playerId}
            onClick={() => handleClick(player.playerId)}
        >
            {isFavourited ? (
                <SvgIcon icon="pin-filled" className="icon favourites-filled" />
            ) : (
                <SvgIcon icon="pin-empty" className="icon favourites-empty" />
            )}

            {getTranslation('label.favourite')}
        </button>
    );
};

FavouriteButton.propTypes = {
    player: PropTypes.object.isRequired,
    onPlayerFavouriteClick: PropTypes.func,
    favourites: PropTypes.array,
    isAFLW: PropTypes.bool
};
